export const PAYMENT_OPTIONS = {
  transferencia: "transferencia-bancaria",
  valeVista: "vale-vista"
};
